import * as yup from 'yup'
import { Entities } from '../../entities/api/entities'

export const categoriesSchema = yup.object({
	type: yup
		.string()
		.oneOf(Object.values(Entities), 'Tipo no válido')
		.required('Debes seleccionar el tipo'),
	name: yup.string().required('Debes escribir el nombre').min(5).max(50),
})
